import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Nav, Container } from 'react-bootstrap';

const IndexNavbar = () => {
  const [navbarOpen, setNavbarOpen] = useState(false);
  const history = useHistory();

  // Logique d'authentification
  const token = localStorage.getItem("token");
  let isAuthenticated = false;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp > currentTime && decodedToken.role === "client") {
        isAuthenticated = true;
      }
    } catch (error) {
      console.error("Invalid token", error);
    }
  }

  // Fonction de déconnexion
  const handleLogout = () => {
    localStorage.removeItem("token");
    history.push("/login");
  };

  const handleNavLinkClick = () => {
    setNavbarOpen(false);
  };

  return (
    <Navbar bg="light" expand="lg" fixed="top" expanded={navbarOpen}>
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src="/log.png"
            alt="logo"
            className="inline-block mr-2"
            style={{ height: '50px', width: '50px' }}
          />
          AidFoundation
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setNavbarOpen(!navbarOpen)} />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            {isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/mademande" onClick={handleNavLinkClick}>Profile</Nav.Link>
                <Nav.Link as="button" onClick={() => { handleLogout(); handleNavLinkClick(); }} style={styles.logoutButton}>
                  Déconnexion
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/" onClick={handleNavLinkClick}>Accueil</Nav.Link>
                <Nav.Link as={Link} to="/demande" onClick={handleNavLinkClick}>S'inscrire</Nav.Link>
                <Nav.Link as={Link} to="/services" onClick={handleNavLinkClick}>Services</Nav.Link>
                <Nav.Link as={Link} to="/login" onClick={handleNavLinkClick}>Connexion</Nav.Link>
                <Nav.Link as={Link} to="/about" onClick={handleNavLinkClick}>A propos</Nav.Link>
                <Nav.Link as={Link} to="/contact" onClick={handleNavLinkClick}>Contactez-nous</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

const styles = {
  logoutButton: {
    background: 'none',
    border: 'none',
    color: 'bluegray-800',
    cursor: 'pointer',
    textDecoration: 'none',
    fontSize: '16px',
    padding: '0',
  },
};

export default IndexNavbar;
